var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.996,
    height: 47.996,
    viewBox: "0 0 47.996 47.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#eceff1;}.b{fill:#607d8b;}.c{fill:#b0bec5;}.d{fill:#fafafa;}.e{fill:#2196f3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.236 -10.878)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.236 10.878)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.709,8.426V1.482A1.492,1.492,0,0,0,55.276.433,1.475,1.475,0,0,0,54.227,0H33.482A1.482,1.482,0,0,0,32,1.482V8.426a13.249,13.249,0,0,0,3.906,9.43l2.89,2.89-2.89,2.89A13.254,13.254,0,0,0,32,33.065v6.947a1.492,1.492,0,0,0,.433,1.049,1.475,1.475,0,0,0,1.049.433l20.745,0a1.482,1.482,0,0,0,1.482-1.482V33.062a13.249,13.249,0,0,0-3.906-9.43l-2.89-2.887,2.89-2.893A13.237,13.237,0,0,0,55.709,8.426Z",
    transform: "translate(-29.036 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.482,2.964A1.482,1.482,0,1,1,1.482,0H28.155a1.482,1.482,0,0,1,0,2.964Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.155,418.964H1.482A1.486,1.486,0,0,1,0,417.482H0A1.486,1.486,0,0,1,1.482,416H28.155a1.486,1.486,0,0,1,1.482,1.482h0A1.486,1.486,0,0,1,28.155,418.964Z",
    transform: "translate(0 -377.473)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.927 5.927)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M64,64v2.5a10.31,10.31,0,0,0,3.038,7.335s5.853,4.594,5.853,4.985h0c0-.391,5.853-4.988,5.853-4.988A10.3,10.3,0,0,0,81.782,66.5V64Z",
    transform: "translate(-64 -64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M64,270.818v-2.5a10.31,10.31,0,0,1,3.038-7.335s5.853-4.594,5.853-4.985h0c0,.391,5.853,4.988,5.853,4.988a10.305,10.305,0,0,1,3.038,7.335v2.5Z",
    transform: "translate(-64 -238.218)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M202.373,264.024h-1.482v-5.465a13.249,13.249,0,0,0-3.906-9.43l-.619-.616a16.189,16.189,0,0,0-2.567,18.475h8.574a1.482,1.482,0,1,0,0-2.964Z",
    transform: "translate(-174.218 -225.496)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(20.996 20.996)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M357.927,301.336a1.488,1.488,0,0,1-1.049-.433l-4.445-4.445a1.492,1.492,0,0,1-.433-1.049v-5.927a1.482,1.482,0,1,1,2.964,0V294.8l4.013,4.013a1.48,1.48,0,0,1-1.049,2.528Z",
    transform: "translate(-319.4 -261.327)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderReview);
export default __webpack_public_path__ + "static/media/under_review.583a2f9bdbee06d360dbe4c1fc639862.svg";
export { ForwardRef as ReactComponent };